module.exports = __webpack_public_path__ + "img/logo_philco.99b6b182.svg";